/**
 * This file contains authentication parameters. Contents of this file
 * is roughly the same across other MSAL.js libraries. These parameters
 * are used to initialize Angular and MSAL Angular configurations in
 * in app.module.ts file.
 */

import { LogLevel, Configuration, BrowserCacheLocation } from '@azure/msal-browser';
import { environment } from '../environments/environment';

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;


export const b2cPolicies = {
  names: {
    signUpSignIn: "B2C_1A_SIGNUP_SIGNIN_EVCPO_PPD",
    editProfile: "B2C_1_profileeditingpoc"
  },
  authorities: {
    signUpSignIn: {
      authority: "https://tasmucpb2cprod.b2clogin.com/tasmucpb2cprod.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN_EVCPO_PPD",
    },
    editProfile: {
      authority: "https://tasmucpb2cprod.b2clogin.com/tasmucpb2cprod.onmicrosoft.com/B2C_1_profileeditingpoc"
    }
  },
  authorityDomain: "tasmucpb2cprod.b2clogin.com"
};

//"https://evsmartchargingdevb2c.b2clogin.com/evsmartchargingdevb2c.onmicrosoft.com/B2C_1_SignIn",

export const msalConfig: Configuration = {
  auth: {
    //clientId: '6b2db47b-ccb6-459a-8512-5099d79884ec',
    clientId: '02238a3a-6bc6-41aa-b9ee-0fd541007ee0',
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    redirectUri: environment.redirectUrlForAzure
  },
}

export const protectedResources = {
  apiMenueList: {
    endpoint: "https://cpo-api-stg.azurewebsites.net/api/Menu/GetUserMenu",
    scopes: {
      read: ["https://tasmucpb2cprod.onmicrosoft.com/02238a3a-6bc6-41aa-b9ee-0fd541007ee0/default"],
      //read: ["openid"],
    }

  }
}
export const loginRequest = {
  scopes: [protectedResources.apiMenueList.scopes.read]
}


export const silentRequest = {
  scopes: [],
  loginHint: "example@domain.net"
};
